import './InfoBlock.sass';

import React, { FC } from 'react';

import { classNames } from '$utils';
import { InfoBlockProps } from './InfoBlock.interface';
import { IcChevron16, IcInfo28 } from '$assets';

export const InfoBlock: FC<InfoBlockProps> = (props) => {
  const { type, children, arrow, title, icon } = props;

  return (
    <div
      className={classNames({
        InfoBlock: true,
        [type]: true,
      })}
    >
      {['warning', 'info', 'tip', 'success'].includes(type) && (
        <div className="InfoBlock__icon">{icon || <IcInfo28 />}</div>
      )}
      <div className="InfoBlock__content">
        {title && <div className="InfoBlock__content__title">{title}</div>}
        <div className="InfoBlock__content__text">{children}</div>
      </div>
      {arrow && (
        <div className="InfoBlock__arrow">
          <IcChevron16 />
        </div>
      )}
    </div>
  );
};
